import SelectDinamico from "../../SelectDinamico";
import ConsultaLocalEstoque from "../../../../lib/json/consultas/LocalEstoque.json"
import { RetornaUsuarioLogado } from "../../../contents/VariaveisGlobais";

function SelectArmazem({campoLocalEstoque, changeLocalEstoque, queryLocalEstoque, disabled = false, empresaLogada, returnOriginal = false, loadDefault = true, bindItem, field, filtraFilial=false, showNoFilter=false, label="Armazém",}){
    const empresaFilial = empresaLogada || localStorage.getItem('empresaFilial')
    const usuarioLogado = RetornaUsuarioLogado(filtraFilial, empresaFilial);
    const parametroEmpresa = usuarioLogado.filtraParametroEmpresasCentroCusto

    const cConsultaDefault = ConsultaLocalEstoque.consulta + " WHERE NNR.D_E_L_E_T_ <> '*' AND NNR_FILIAL = FILIAL(NNR) "
    let filtraCentroCusto =  " AND CTT_CUSTO IS NOT NULL"

    if (parametroEmpresa.centroCusto.length > 0){
        filtraCentroCusto += " AND NNR_XCC IN ('" + parametroEmpresa.centroCusto.join("','") + "')"
    }
    
    const consulta = queryLocalEstoque || ( loadDefault ? cConsultaDefault + filtraCentroCusto : '' )
    const localEstoqueValue = bindItem ? bindItem[field] : campoLocalEstoque;

    return (
        <SelectDinamico
            label={label}
            cText="NNR_CODIGO + ' - ' + item.NNR_DESCRI"
            cValue="NNR_CODIGO"
            campoValue={localEstoqueValue}
            consulta={consulta}
            tabela={ConsultaLocalEstoque.tabelas}
            isMultiplo={false}
            showNoFilter={showNoFilter}
            EmpresaLogada={empresaFilial}
            onchange={(e) => changeLocalEstoque(e)}
            returnOrigem={returnOriginal}
            bindItem={bindItem}
            field={field}
            disabled={disabled}
        />
    )
}

export default SelectArmazem;